import CompanyFeature from '../model/companyFeature'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchCompanyFeatures(companyID: string): Promise<RequestResponse<CompanyFeature[]>> {
  return secureRequest('GET', url('/v2/companyFeatures', { companyID }))
}
